module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-132.77959f03.svg";